module.exports = __webpack_public_path__ + "assets/Lato-Regular.983b0caf336e8542214fc17019a4fc5e0360864b92806ca14d55c1fc1c2c5a0f.woff2";